var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'core', 'model/base', 'component/reconciliation/local-storage'], function($, _, core, BaseModel, LocalStorage) {
  var ReconciliationModel;
  return ReconciliationModel = (function(_super) {

    __extends(ReconciliationModel, _super);

    function ReconciliationModel() {
      ReconciliationModel.__super__.constructor.apply(this, arguments);
    }

    ReconciliationModel.prototype.pathRoot = core.getConfig().apiPrefix + 'reconciliation.json';

    ReconciliationModel.prototype.previewTransactions = [];

    ReconciliationModel.prototype.isFetching = false;

    ReconciliationModel.prototype.defaults = function() {
      return {
        clientId: null,
        startDate: null,
        fileName: null,
        ledgerName: null,
        transactions: [],
        balancePreviews: [],
        note: null
      };
    };

    ReconciliationModel.prototype.initialize = function() {
      this.listenTo(this, 'change:transactions', this.syncTransactions);
      this.internNotesCache = new LocalStorage('InternalNotes', this.get('id'));
      return this.suggestedCategoriesCache = new LocalStorage('SuggestedCategories', this.get('id'));
    };

    ReconciliationModel.prototype.fetch = function(options) {
      var promise,
        _this = this;
      promise = ReconciliationModel.__super__.fetch.call(this, options);
      return promise.done(function(result) {
        return _this.previewTransactions = _.map(result.transactions, function(transaction) {
          return _.clone(transaction);
        });
      });
    };

    ReconciliationModel.prototype.getTransaction = function(transactionId) {
      return _.findWhere(this.get('transactions'), {
        id: transactionId
      });
    };

    ReconciliationModel.prototype.resetToPreview = function() {
      return this.set('transactions', this.previewTransactions);
    };

    ReconciliationModel.prototype.getStats = function() {
      var accuracy, accurateMatches, categorizedTxns, coverage, transactions;
      transactions = this.get('transactions');
      categorizedTxns = transactions.filter(function(x) {
        return x.categorizerLedger != null;
      });
      coverage = categorizedTxns.length / transactions.length;
      accurateMatches = categorizedTxns.reduce(function(acc, tx) {
        if (tx.categorizerLedger !== tx.defaultLedgerId) {
          return acc - 1;
        } else {
          return acc;
        }
      }, categorizedTxns.length) / categorizedTxns.length;
      accuracy = accurateMatches > 0 ? accurateMatches / categorizedTxns.length : 1;
      return {
        accuracy: accuracy,
        coverage: coverage
      };
    };

    ReconciliationModel.prototype.startReconciliation = function() {
      var transaction, values, _i, _len, _ref, _ref1;
      if ((_ref = window.heap) != null) {
        _ref.track('recUI-categorizationStats', this.getStats());
      }
      values = {};
      _ref1 = this.get('transactions');
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        transaction = _ref1[_i];
        values[transaction.id] = {
          vendorName: transaction.vendorName,
          applySalesTax: !!transaction.applySalesTax,
          internalNotes: transaction.internalNotes,
          suggestedLedgers: transaction.suggestedLedgers,
          categorizerMethod: transaction.categorizerMethod,
          categorizerLedgerId: transaction.categorizerLedgerId,
          categorizerRule: transaction.categorizerRule,
          categorizerUuid: transaction.categorizerUuid
        };
        if (!transaction.multiline) {
          values[transaction.id].selectedLedger = transaction.defaultLedgerId;
        }
      }
      return this.customCall('', 'PUT', JSON.stringify(values));
    };

    ReconciliationModel.prototype.markAsProcessed = function() {
      return this.customCall('/mark_as_ignored', 'PUT');
    };

    ReconciliationModel.prototype.downloadAsXls = function() {
      return location.href = this.url() + '/downloadAsXls';
    };

    ReconciliationModel.prototype.saveCache = function(transactionId, data, cache) {
      var cachedData;
      cachedData = cache.load();
      cachedData[transactionId] = data;
      return cache.save(cachedData);
    };

    ReconciliationModel.prototype.saveInternalNotesCache = function(transactionId, notes) {
      return this.saveCache(transactionId, notes, this.internNotesCache);
    };

    ReconciliationModel.prototype.destroyInternalNotesCache = function() {
      return this.internNotesCache.remove();
    };

    ReconciliationModel.prototype._mergeInternalNotes = function(internalNotes, cache) {
      var cachedItem, timestamps, _i, _len, _results;
      timestamps = _.pluck(internalNotes, 'timestamp');
      _results = [];
      for (_i = 0, _len = cache.length; _i < _len; _i++) {
        cachedItem = cache[_i];
        if (!_.contains(timestamps, cachedItem != null ? cachedItem.timestamp : void 0)) {
          _results.push(internalNotes != null ? internalNotes.push(cachedItem) : void 0);
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    ReconciliationModel.prototype.destroySuggestedCategoriesCache = function() {
      return this.suggestedCategoriesCache.remove();
    };

    ReconciliationModel.prototype.saveSuggestedCategoriesCache = function(transactionId, suggestedCategories) {
      return this.saveCache(transactionId, suggestedCategories, this.suggestedCategoriesCache);
    };

    ReconciliationModel.prototype.syncTransactions = function() {
      var cache, internalNotesCache, suggestedCategoriesCache, transaction, transactionId, transactions;
      internalNotesCache = this.internNotesCache.load();
      suggestedCategoriesCache = this.suggestedCategoriesCache.load();
      transactions = this.get('transactions');
      for (transactionId in internalNotesCache) {
        cache = internalNotesCache[transactionId];
        transaction = this.getTransaction(transactionId);
        if (transaction != null ? transaction.internalNotes.length : void 0) {
          this._mergeInternalNotes(transaction != null ? transaction.internalNotes : void 0, cache);
        } else {
          if (transaction != null) {
            transaction.internalNotes = cache || [];
          }
        }
      }
      for (transactionId in suggestedCategoriesCache) {
        cache = suggestedCategoriesCache[transactionId];
        transaction = this.getTransaction(transactionId);
        if (transaction != null) {
          transaction.suggestedLedgers = (suggestedCategoriesCache != null ? suggestedCategoriesCache[transactionId] : void 0) || [];
        }
      }
      return this.set('transactions', transactions);
    };

    return ReconciliationModel;

  })(BaseModel);
});
